import React from 'react';
import { Button, Flex, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text } from '@chakra-ui/react';
import useModalHeaderZIndex from '../../hooks/useModalHeaderZIndex.ts';

interface Props {
  isOpen: boolean;
  title: string;
  description: string;
  confirmLabel: string;
  cancelLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const AleaConfirmModal: React.FC<Props> = ({ isOpen, title, description, confirmLabel, cancelLabel, onConfirm, onCancel }) => {
  useModalHeaderZIndex(isOpen);

  return (
    <Modal isOpen={isOpen} onClose={onCancel} isCentered>
      <ModalOverlay bg="blackAlpha.700" zIndex={2000} />
      <ModalContent borderRadius="20px" p="25px" maxW="380px" w="380px">
        <ModalHeader textAlign="center" color="sunsetEmber.500" fontSize="20px" fontWeight="600" mb="12px" p="0">
          {title}
        </ModalHeader>
        <ModalBody mb="12px" p="0">
          <Text textAlign="center" fontSize="16px" fontWeight="400" color="#000">
            {description}
          </Text>
        </ModalBody>
        <ModalFooter p="0">
          <Flex w="100%" justifyContent="center" gap="20px">
            <Button variant="outline" borderColor="invalid.500" color="invalid.500" borderRadius="16px" px="15px" py="10px" onClick={onCancel} whiteSpace="none" h="auto" fontWeight={400}>
              {cancelLabel}
            </Button>
            <Button bg="#2B4956" color="white" borderRadius="16px" px="15px" py="10px" onClick={onConfirm} _hover={{ bg: '#2B4956' }} whiteSpace="none" h="auto" fontWeight={400}>
              {confirmLabel}
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AleaConfirmModal;


